import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { AccountingDistributionExternalRouter } from './accounting-distribution-external.router';
import { reducers } from './state/accounting-distribution-external.selectors';

@NgModule({
  imports: [
    AccountingDistributionExternalRouter,
    StoreModule.forFeature('accountingDistributionExternal', reducers),
  ],
  declarations: []
})
export class AccountingDistributionExternalScreenModule { }